import { Link } from 'react-router-dom';
import { categories, dramas } from '@/mocks/dramas';

const catImages: Record<string, string> = {
  guochan:
    'https://readdy.ai/api/search-image?query=Stylized%20modern%20Chinese%20television%20production%20scene%20with%20warm%20orange%20studio%20lighting%20against%20deep%20blue%20backdrop%2C%20minimal%20cinematic%20abstract%20composition%2C%20professional%20film%20set%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=home-cat-guochan&orientation=landscape',
  hanju:
    'https://readdy.ai/api/search-image?query=Stylized%20romantic%20Korean%20drama%20scene%20with%20soft%20warm%20orange%20sunset%20light%20and%20deep%20blue%20evening%20sky%2C%20abstract%20minimal%20cinematic%20composition%2C%20gentle%20emotional%20film%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=home-cat-hanju&orientation=landscape',
  meiju:
    'https://readdy.ai/api/search-image?query=Dramatic%20American%20television%20scene%20with%20moody%20deep%20blue%20shadows%20and%20warm%20orange%20practical%20lights%2C%20abstract%20minimal%20cinematic%20composition%2C%20suspenseful%20film%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=home-cat-meiju&orientation=landscape',
  guzhuang:
    'https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20palace%20silhouette%20with%20warm%20orange%20lantern%20glow%20against%20deep%20blue%20night%20sky%2C%20abstract%20minimal%20cinematic%20composition%2C%20elegant%20historical%20film%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=home-cat-guzhuang&orientation=landscape',
  dushi:
    'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20dusk%20with%20glass%20towers%2C%20deep%20blue%20sky%20and%20warm%20orange%20window%20lights%2C%20abstract%20minimal%20cinematic%20composition%2C%20contemporary%20urban%20film%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=home-cat-dushi&orientation=landscape',
};

const catIcons: Record<string, string> = {
  guochan: 'ri-film-line',
  hanju: 'ri-heart-line',
  meiju: 'ri-movie-line',
  guzhuang: 'ri-book-2-line',
  dushi: 'ri-building-2-line',
};

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {categories.map((c) => {
        const count = dramas.filter((d) => d.category === c.slug).length;
        return (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group relative h-40 overflow-hidden rounded-lg border border-background-200 lg:h-44"
          >
            <img
              src={catImages[c.slug]}
              alt={`${c.name}分类封面`}
              title={`${c.name} - 最新电视剧推荐`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4">
              <div>
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className={`${catIcons[c.slug]} text-xl`} />
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{c.name}</h3>
                <p className="text-xs text-background-300">{count} 部剧集</p>
              </div>
              <i className="ri-arrow-right-up-line text-xl text-background-100 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
          </Link>
        );
      })}
    </div>
  );
}